module.exports = __webpack_public_path__ + "img/login-bg-image.a3ebacd5.jpeg";